import { render, staticRenderFns } from "./manage-addon.vue?vue&type=template&id=73ff3dd4&scoped=true&"
import script from "./manage-addon.vue?vue&type=script&lang=ts&"
export * from "./manage-addon.vue?vue&type=script&lang=ts&"
import style0 from "./manage-addon.vue?vue&type=style&index=0&id=73ff3dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff3dd4",
  null
  
)

export default component.exports